import Modal from "react-modal";

import "./WorkingReasonsModal.css";
import { workingReasonText } from "shared/utils/caseUtils";

import { useAppSelector } from "store/hooks";

type WorkingReasonsModalProps = {
  accession?: string;
  reasons?: any;
  isOpen: boolean;
  setReasonsModal: Function;
};

export const WorkingReasons = ({
  accession,
  reasons,
}: {
  accession?: string;
  reasons?: any;
}) => {
  const pendingLabWorkWorkingReason = useAppSelector(
    ({ sys }) => !!sys.features.pendingLabWorkWorkingReason
  );

  return (
    <>
      <h3 className="ReasonModal__header">
        Working Reasons for {accession || "Unknown"}
      </h3>
      {reasons &&
        Object.keys(reasons).map((key: string) => {
          return (
            <section className="ReasonModal__section" key={key}>
              <span className="ReasonModal__reason">
                {workingReasonText(reasons, key, pendingLabWorkWorkingReason)}
              </span>
            </section>
          );
        })}
    </>
  );
};

const WorkingReasonsModal = ({
  accession,
  reasons,
  isOpen,
  setReasonsModal,
}: WorkingReasonsModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setReasonsModal(false)}
      contentLabel="Case Workflow"
      className="Modal"
      overlayClassName="Overlay"
    >
      <WorkingReasons accession={accession} reasons={reasons} />
    </Modal>
  );
};

export default WorkingReasonsModal;
